<template>
  <div class="container">
    <van-search
      v-model="searchTheme"
      placeholder="搜索"
      left-icon="searchImg"
      shape="round"
      @search="onSearch"
      >
      <div slot="left-icon" class="searchImg">
        <img :src="searchImg" alt="">
      </div>
    </van-search>
    <div class="teacher-list">
      <van-radio-group v-model="checked" @change="radioChange">
        <div v-for="(item,index) in listData" :key="index" class="m-b-35">
          <p class="subject" @click="isShowFun(item)">
            <img src="./img/triangle.png" :class="item.isShow?'':'is-rotate'" alt="">
            <span>{{item.DisciplineName}}</span>
          </p>
          <div class="name-list" v-if="item.isShow">
              <van-cell v-for="(item1,index1) in item.list">
                <van-radio checked-color="#2258e8" :name="item1.TeacherID+','+item.DisciplineID">
                  <img class="head" src="./img/head.png" alt="">
                  {{item1.FullName}}
                </van-radio>
              </van-cell>
          </div>
        </div>
      </van-radio-group>
    </div>
    <div class="sigle-bottom-btn">
      <van-button type="info"
          @click="clickBtn"
          round
          size="large">
        确定
      </van-button>
    </div>
  </div>
</template>
<script>
import SingleBottomBtn from "@/components/SingleBottomBtn";
export default {
  components: {
    SingleBottomBtn
  },
  name: "",
  data() {
    return {
      listData:[],
      listDataCopy:[],
      searchImg: require('./img/search.png'),
      checked:'',

      schooleVal:'',
      AcademicSessionID:'',

      searchTheme:'',

      teacherData:{}

    };
  },
  created() {
    this.schooleVal=this.$route.query.schooleVal
    this.AcademicSessionID=this.$route.query.AcademicSessionID//学期
    this.checked = this.$route.query.teacherID
    this.getSchoole();
  },
  mounted() {},
  methods: {
    onSearch() {
      let searchData = JSON.parse(JSON.stringify(this.listDataCopy))
      searchData.forEach(item => {
        item.list = item.list.filter(ele => ele.FullName.indexOf(this.searchTheme) != -1)
      })
      searchData = searchData.filter(e => e.list.length)
      this.listData = searchData
    },
    // 匹配到教师名字和id
    radioChange(val){
      this.listData.forEach(item=>{
        item.list.forEach(item1=>{
          if(item1.TeacherID+'' === val.split(",")[0]){
            this.teacherData = item1
          }
        })
      })
    },
    isShowFun(item){
      this.$nextTick(()=>{
        item.isShow=!item.isShow
        this.$set(item,'isShow',item.isShow)
        this.$forceUpdate()//强制更新
      })
    },
    clickBtn(){
       this.$router.push({
        path: 'teacherSchedule',
        query: {
          schooleVal:JSON.stringify(this.$route.query.schooleVal),
          AcademicSessionID:this.$route.query.AcademicSessionID,
          teacherData:JSON.stringify(this.teacherData),
          teacherID:this.checked
        },
      })
    },
    //获取老师
    async getSchoole() {
      this.xy.loading();
      let res = await this.xyapi.post(this.$store.state.apiPath + "/api/ReportPermissionTimeTable/GetMobilePermissionTimeTableTeacherIncludeList",{
        ApplicationID:this.$store.state.common.menuIDs[1],
        AcademicSessionID:this.AcademicSessionID,
        SchoolDistrictID:this.schooleVal.value
      });
      this.xy.unloading();
      if (res.success) {
        this.listData = res.data
        this.listData.forEach(item=>{
          item.isShow=true
        })
        this.listDataCopy = this.listData
      } else {
        this.$toast.fail(res.data);
      }
    },

  }
};
</script>
<style lang="less" scoped>
// 我的样式
.searchImg {
    width: 32px;
    height: 32px;
    position: relative;
    img {
      width: 32px;
      height: 32px;
      left: 0;
      top: 0;
    }
  }
.teacher-list{
  padding: 24px 29px;
  .m-b-35{
    margin-bottom: 35px;
  }
  p.subject{
   display: flex;
   align-items: center;
   .is-rotate{
     transform:rotate(-90deg)
   }
   img{
     width: 15px;
     height: 13px;
   }
   span{
     margin-left: 9px;
     color: #666666;
   }
 }
 .name-list{
   margin-top:10px;
   .head{
     width: 60px;
     height: 60px;
     margin-left: 10px;
   }
   .van-cell{
   }
 }
}
.sigle-bottom-btn {
  height: 128px;
  line-height: 128px;
  background: #000;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 21px 0px rgba(186, 186, 186, 0.44);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 5px 50px;
  .van-button--info {
    color: #fff;
    background-color: #2258e8;
    border: 1px solid #2258e8;
  }
  .van-button--large{
    height: 35px !important;
    line-height: 35px !important;
  }
}
.container {
  position: relative;
  background: #fff;
  height: 100vh;
  overflow: auto;
  padding-bottom: 100px;
}
</style>
